export const defaultAvatar =
  'https://d3oxx2q4ivbizb.cloudfront.net/sites/default/files/styles/thumbnail/public/default_images/default-profile.jpeg';
export const defaultGroupAvatar =
  'https://d3oxx2q4ivbizb.cloudfront.net/sites/default/files/2023-03/default_chat_group.png';
